<template>
  <div
    class="picker"
    @click="toggle">
    <div
      v-for="item in list"
      :key="item.hex"
      :data-color="item.color"
      :style="`border:0.12rem solid #${borderColor==='b'?'fffffb':'0c0c0c'};background-color:#${item.hex};z-index:${item.color === seriesFilters?999:1};`"
      class="circle" />
    <div
      :style="`border:0.12rem solid #${borderColor==='b'?'fffffb':'0c0c0c'};z-index:${'all' === currentColor?999:1};`"
      class="circle linear-gradient"
      data-color="all" />
  </div>
</template>

<script>
// Genera la lista de colores en grupos.
import anime from 'animejs'
export default {
  props: {
    borderColor: {
      type: String,
      default: 'd',
    },
    seriesFilters: {
      type: String,
      default: null,
    },
  },
  data () {
    return {
      isOpen: false,
      anime: null,
      list: [
        { hex: 'fffffb', color: 'w' },
        { hex: '0c0c0c', color: 'b' },
        { hex: '800000', color: 'm' },
        { hex: '8A6BBE', color: 'p' },
        { hex: '7db9de', color: 'c' },
        { hex: '00AA90', color: 'g' },
        { hex: 'f7df40', color: 'y' },
        { hex: 'ffa500', color: 'o' },
        { hex: 'cb1b45', color: 'r' },
      ],
      currentColor: null,
    }
  },
  mounted () {},
  methods: {
    open () {
      anime({
        targets: document.querySelectorAll('.circle'),
        translateY: [
          '0rem',
          function (el, i, l) {
            return i * 2.2 + 'rem'
          },
        ],
        duration: 100,
        easing: 'easeInSine',
      })
    },
    close () {
      anime({
        targets: document.querySelectorAll('.circle'),
        translateY: [
          function (el, i, l) {
            return i * 2.2 + 'rem'
          },
          '0rem',
        ],
        duration: 100,
        easing: 'easeInSine',
      })
    },
    toggle (e) {
      if (this.isOpen === false) {
        this.open()
        this.isOpen = true
      } else {
        this.close()
        this.$emit('seriesChange', (this.currentColor = e.target.dataset.color))
        this.isOpen = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.picker {
  position: relative;
  height: 100%;
  width: 100%;
  .circle {
    box-sizing: border-box; // 待定
    transition: all 1s;
    position: absolute;
    height: 100%;
    width: 100%;
    //border-radius: 50%;
  }
  .linear-gradient {
    z-index: 998;
    background: linear-gradient(
      to top,
      #0c0c0c,
      #010101,
      #800000,
      #8A6BBE,
      #7db9de,
      #00AA90,
      #f7df40,
      #ffa500,
      #cb1b45
    );
  }
}
</style>
